import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { RxMethods } from 'src/app/common/services/rxjs.service';
import { masterGridConfig, validationMsgConfig, validationConfig } from '../../../app-enum.enum';

@Injectable()
export class LocationCreateService {

  constructor(private rxMethods: RxMethods) { }

  /*locationCreateConfig = {
    'showSideBar': false,
    'showReset': false,
    'isReset': false
};*/

  getLocationFilterConfig = {
    'showSideBar': false,
    'showReset': false
  };
  selectedLocationNo: string;
  tableSource = this.rxMethods.createSubjectService();
  locationList = [];
  activeReqIndex: number;
  isFromTransaction = false;
  auditList = [];

  setGridSource(gridArray: any) {
    this.tableSource.next(gridArray);
  }

  //Form
  getLocationCreateFormTemplate(scope) {
    return [{
      'id': 'strLocCode',
      'labelName': 'Location Code',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'validations': [Validators.required],
      'isReadOnly': false,
      'isVisible': true,
      'position': 0,
      'class': 'col-md-3',
      'isHelper': true,
      'scope': scope,
      'helperConfig': {
        'title': 'Location Help',
        'modalComponent': scope.getModalComponent,
        'helperCallback': scope.updateFormValues
      },
      'onEnter': scope.updateFormValues
    }, {
      'id': 'strLocName',
      'labelName': 'Location Name',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': false,
      'changeApi': '',
      'validations': [Validators.required],
      'position': 1,
      'class': 'col-md-3'
    }, {
      'id': 'strLocType',
      'labelName': 'Location Type',
      'type': 'search',
      'minlength': 1,
      'placeholder': 'Select Location Type',
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'readonly': false,
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [Validators.required],
      'position': 2,
      'class': 'col-md-3'
    }, {
      'id': 'strStatus',
      'labelName': 'Status',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': true,
      'changeApi': '',
      'validations': [],
      'position': 3,
      'class': 'col-md-3'
    }, {
      'id': 'strRegion',
      'labelName': 'Region',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': true,
      'changeApi': '',
      'validations': [],
      'position': 3,
      'class': 'col-md-3'
    },
    //   {
    //   'id': 'strRegion',
    //   'labelName': 'Region',
    //   'type': 'search',
    //   'minlength': 1,
    //   'isVisible': true,
    //   'placeholder': 'Select Zone',
    //   'model': '',
    //   'changeApi': '',
    //   'displayField': 'value',
    //   'valueField': 'id',
    //   'datasource': [],
    //   'validations': [Validators.required],
    //   'position': 4,
    //   'class': 'col-md-3'
    // }, 
    {
      'id': 'strAddress',
      'labelName': 'OP Division ',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': true,
      'changeApi': '',
      'validations': [],
      'position': 5,
      'class': 'col-md-3'
    }, {
      'id': 'strAddressSub',
      'labelName': 'cluster ',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': true,
      'changeApi': '',
      'validations': [],
      'position': 6,
      'class': 'col-md-3'
    }, {
      'id': 'strTeritoryId',
      'labelName': 'PE Cluster',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'validations': [],
      'isReadOnly': true,
      'isVisible': true,
      'position': 7,
      'class': 'col-md-3',
      'isHelper': false,
      'scope': scope,
      'helperConfig': {
        'title': 'Territory Help',
        'modalComponent': scope.getModalComponent,
        'helperCallback': scope.updateFormValues
      },
      'onEnter': scope.updateFormValues
    }, {
      'id': 'strAddressBase',
      'labelName': 'SAP Code',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': true,
      'changeApi': '',
      'validations': [],
      'position': 8,
      'class': 'col-md-3'
    }, {
      'id': 'strAddress1',
      'labelName': 'Address1',
      'type': 'input',
      'inputType': 'text',
      'isVisible': false,
      'isReadOnly': false,
      'changeApi': '',
      'validations': [],
      'position': 9,
      'class': 'col-md-3'
    }, {
      'id': 'strAddress2',
      'labelName': 'Address2',
      'type': 'input',
      'inputType': 'text',
      'isVisible': false,
      'isReadOnly': false,
      'changeApi': '',
      'validations': [],
      'position': 10,
      'class': 'col-md-3'
    }, {
      'id': 'strAddress3',
      'labelName': 'Address3',
      'type': 'input',
      'inputType': 'text',
      'isVisible': false,
      'isReadOnly': false,
      'changeApi': '',
      'validations': [],
      'position': 11,
      'class': 'col-md-3'
    }, {
      'id': 'strCountry',
      'labelName': 'Country',
      'type': 'search',
      'minlength': 1,
      'placeholder': 'Select Country',
      'isVisible': false,
      'model': '',
      'changeApi': '',
      'readonly': false,
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [],
      'onSuggestionSelected': scope.fetchDataForSelectedItem,
      'scope': scope,
      'position': 12,
      'class': 'col-md-3'
    }, {
      'id': 'strState',
      'labelName': 'State',
      'type': 'search',
      'placeholder': 'Select State',
      'minlength': 1,
      'isVisible': false,
      'model': '',
      'changeApi': '',
      'readonly': false,
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': {
        'id': 'ALL',
        'value': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'onSuggestionSelected': scope.fetchDataForSelectedItem,
      'scope': scope,
      'position': 13,
      'class': 'col-md-3'
    }, {
      'id': 'strCity',
      'labelName': 'City',
      'type': 'search',
      'minlength': 1,
      'placeholder': 'Select City',
      'isVisible': false,
      'model': '',
      'changeApi': '',
      'readonly': false,
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': {
        'id': 'ALL',
        'value': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'position': 14,
      'class': 'col-md-3'
    }, {
      'id': 'strArea',
      'labelName': 'Area',
      'type': 'input',
      'inputType': 'text',
      'isVisible': false,
      'isReadOnly': false,
      'changeApi': '',
      'validations': [],
      'position': 15,
      'class': 'col-md-3'
    }, {
      'id': 'strZipCode',
      'labelName': 'Zip Code',
      'type': 'input',
      'inputType': 'text',
      'isVisible': false,
      'isReadOnly': false,
      'model': '',
      'changeApi': '',
      // 'min':'',
      'max': 6,
      'validations': [Validators.pattern(validationConfig.zipCodeValidation)],
      'error_message': {
        'pattern': validationMsgConfig.numericValidationMessage
      },
      // 'pattern': '^[1-9]\d*$',
      // 'validations': Validators.max(5),
      // 'validations': Validators.pattern('^[1-9]\d*$'),
      'position': 16,
      'class': 'col-md-3'
    }, {
      'id': 'strGeoLattitude',
      'labelName': 'Latitude',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': false,
      'isdecimal': '',
      'changeApi': '',
      'validations': [Validators.required, Validators.pattern('^[0-9.-]*$')],
      'error_message': {
        'pattern': validationMsgConfig.latlngValidationMessage
      },
      'position': 17,
      'class': 'col-md-3'
    }, {
      'id': 'strGeoLongitude',
      'labelName': 'Longitude',
      'type': 'input',
      'inputType': 'text',
      'isVisible': true,
      'isReadOnly': false,
      'isdecimal': '',
      'changeApi': '',
      'validations': [Validators.required, Validators.pattern('^[0-9.-]*$')],
      'error_message': {
        'pattern': validationMsgConfig.latlngValidationMessage
      },
      'position': 18,
      'class': 'col-md-3'
    }, {
      'id': 'strh2s',
      'labelName': 'H2S Location',
      'type': 'search',
      'minlength': 1,
      'isVisible': true,
      'placeholder': 'Select Location',
      'model': '',
      'changeApi': '',
      'readonly': false,
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [],
      'position': 19,
      'class': 'col-md-3'
    }, {
      'id': 'strFenceCode',
      'labelName': 'Fence Name',
      'type': 'search',
      'minlength': 1,
      'isVisible': true,
      'placeholder': 'Select Fence',
      'model': '',
      'changeApi': '',
      'readonly': false,
      'displayField': 'value',
      'valueField': 'id',
      'datasource': [],
      'validations': [],
      'scope': scope,
      'onSuggestionSelected': scope.fetchDataForFence,
      'position': 19,
      'class': 'col-md-3'
    }, {
      'id': 'strRouteCategory',
      'labelName': 'Planning Location',
      'type': 'multiselect',
      'isVisible': true,
      'isDisabled': false,
      'changeApi': '',
      'validations': [],
      'position': 1,
      'optionLabel': 'value',
      'patchValue': '',
      'selector': ',',
      'seperator': ',',
      'class': 'col-md-6 multi_value',
      'labelClass': 'col-md-3 plan_cls_lable',
      'elemClass': 'col-md-9 plan_cls_input',
      'datasource': ''
    }, {
      'id': 'chkAuditLocation',
      'labelName': 'Audit Location?',
      'type': 'checkbox',
      'isVisible': true,
      'isDisabled': false,
      'changeApi': '',
      'validations': [],
      'isBinary': true,
      'position': 11,
      'class': 'col-md-3'
    }];
  }
}
